/**
 * Pure helpers for interpreting the protected `/billing/entitlements` response.
 * These functions never inspect the browser-writable user profile.
 */
const ACTIVE_SUBSCRIPTION_STATUSES = new Set(['active', 'trialing']);

export function hasPaidAccess(entitlements) {
  return Boolean(
    entitlements
    && String(entitlements.plan || '').toLowerCase() === 'pro'
    && ACTIVE_SUBSCRIPTION_STATUSES.has(String(entitlements.subscriptionStatus || '').toLowerCase()),
  );
}

export function hasRunningScoutAccess(entitlements, now = Date.now()) {
  if (hasPaidAccess(entitlements)) return true;
  const scout = entitlements?.scout;
  if (!scout || typeof scout !== 'object' || scout.active !== true) return false;
  if (!scout.trialActive) return scout.active === true;
  return Number(scout.trialEndsAt || 0) > now;
}

export function subscriptionLabel(entitlements) {
  if (hasPaidAccess(entitlements)) {
    if (entitlements?.billing?.provider === 'whish') return 'JOBSEEQR Pro — Whish manual renewal';
    return entitlements?.billing?.cancelAtPeriodEnd ? 'Pro — cancellation scheduled' : 'JOBSEEQR Pro';
  }
  return hasRunningScoutAccess(entitlements) ? 'Free — Scout trial active' : 'Free';
}
